import { z } from 'zod'

export const createGovernmentAllocationAnnulativeEntrySchema = z.object({
  office_number: z.string({ message: 'Campo Número do ofício é obrigatório' }).min(1, {
    message: 'Campo Número do ofício é obrigatório',
  }),
  file: z
    .custom<File | string>()
    .optional()
    .refine((file) => !!file && typeof file !== 'string', {
      message: 'Campo Anexo é obrigatório',
    }),
  file_name: z.string().optional(),
})

export type CreateGovernmentAllocationAnnulativeEntryValidationSchema = z.infer<
  typeof createGovernmentAllocationAnnulativeEntrySchema
>
